export default __webpack_public_path__ + "static/media/1245.01351551.png";